import { atomWithStorage, createJSONStorage } from "jotai/utils";
import type {
	ClientFinancialPlanExpenseNameEnum,
	ClientFinancialPlanExpenseTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";

export type FinanceState = {
	income: {
		name: string;
		amount: number;
	}[];
	expenses: {
		type: ClientFinancialPlanExpenseTypeEnum;
		name: ClientFinancialPlanExpenseNameEnum;
		monthlyPayment: number;
		sustainableAmount: number;
	}[];
};

const defaultState: FinanceState = {
	income: [],
	expenses: [],
};

export const financeState = atomWithStorage<FinanceState>(
	"MYPLANN_FINANCE_STATE",
	defaultState,
	createJSONStorage(() => sessionStorage),
);
